import React, { useState, useEffect } from "react";
import styles from "./product.module.css";
import { useSelector } from "react-redux";
/* import { useState } from "react"; */
import { Link } from "react-router-dom";
import AddToCart from "../QtyCounter/AddToCart";

function Product({ product }) {
  return (
    <>
      {!product.deletedAt ? (
        <div className="col-sm-12 col-md-6 col-lg-3">
          <div className={styles.card}>
            <div className={styles.iconContainer}>
              {product.glutenfree ? (
                <img
                  className={styles.glutenFree}
                  src="../img/gluten-free.svg"
                  alt="gluten-free"
                />
              ) : (
                <></>
              )}
              {product.sugarfree ? (
                <img
                  className={styles.sugarFree}
                  src="../img/sugar-free.svg"
                  alt="sugar-free"
                />
              ) : (
                <></>
              )}
            </div>
            {product.stock === 0 ? (
              <img
                className={styles.stockBadge}
                src="../img/no-stock.png"
                alt="no-stock"
              />
            ) : (
              <></>
            )}
            <img
              src={product.pictures[0].img1}
              alt={product.name}
              className={styles.background + " rounded"}
            />
            <div className={styles.cardDetail}>
              <h5 className="text-center">{product.name}</h5>
              <p className="text-center fs-6 px-4">{product.description}</p>

              {product.stock > 0 ? (
                <>
                  <Link
                    to={`/${product.slug}`}
                    className={styles.btnInfo + " btn mb-5 text-white"}
                  >
                    Ver detalle
                  </Link>
                  <AddToCart product={product} />{" "}
                </>
              ) : (
                <></>
              )}
            </div>
          </div>
          <span
            className={
              styles.spanDetail + " d-flex justify-content-between px-1"
            }
          >
            <small className="">{product.name}</small>
            <small className="text-end fw-bold">$ {product.price}</small>
          </span>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export default Product;
